module.exports = __webpack_public_path__ + "img/telehealth-statistics-clinician-dashboard.31e9ef04.png";